/* eslint-disable @next/next/no-img-element */
import React, { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { StructuredText, renderRule } from "react-datocms";
import { isHeading } from "datocms-structured-text-utils";
import { createDatoClient } from "services/datocms";
import { getSdk, HomePageInstaFeedQuery } from "services/datocms/generated";

const HomepageInstafeed: FC = () => {
  const router = useRouter();
  const [queryResult, setQueryResult] =
    useState<NonNullable<HomePageInstaFeedQuery["homepageInstafeed"]>>();
  useEffect(() => {
    getSdk(createDatoClient(router?.isPreview))
      .HomePageInstaFeed()
      .then((res) => {
        setQueryResult(res?.homepageInstafeed || undefined);
      });
  }, [router?.isPreview]);

  if (!queryResult) return <div></div>;

  return (
    <div>
      <StructuredText
        data={queryResult.title?.value}
        customNodeRules={[
          renderRule(isHeading, ({ children, key }) => {
            return (
              <h3 key={key} className="container instafeed-title focus">
                {children}
              </h3>
            );
          }),
        ]}
      />
      <div className="wp-block-columns container instafeed-list">
        {queryResult.images.map((image, i) => {
          return (
            <div className="wp-block-column" key={image.id}>
              <figure className="wp-block-image size-large">
                <img
                  loading="lazy"
                  width="1024"
                  height="1024"
                  src={image.url}
                  alt={image.alt || ""}
                  className={`wp-image-202${i + 1}`}
                  sizes="(max-width: 1024px) 100vw, 1024px"
                />
              </figure>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomepageInstafeed;
